module.exports = __webpack_public_path__ + "img/zsjm-1.3f076827.webp";